import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByUtmQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByUtmQueryType,
  AnalyticsViewsByUtmQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByUtmQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByUtmQueryType,
    AnalyticsViewsByUtmQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByUtmQueryType,
    AnalyticsViewsByUtmQueryVariablesType
  >(AnalyticsViewsByUtmQuery, options);
};
